import { environment } from '../../../../environments/environment';
import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from './../../services/local-storage/local-storage.service';
import { Observable } from 'rxjs';

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
    constructor(private _storage: LocalStorageService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = this._storage.getItemString(environment.LOCAL_STORAGE.AUTHORIZATION_TOKEN);
        const emailEndpoint = environment.NOTIFICACIONES_API.PREFIJO_URL + environment.NOTIFICACIONES_API.ENDPOINT_EMAIL;
        
        if(!req.headers.has('Authorization')){
            if (token && (req.url !== emailEndpoint && req.url !== environment.SEGURIDAD.API_AUTENTICACION_URL)) {
                req = req.clone({
                    setHeaders: {
                        Authorization: `Bearer ${token}`,
                    }
                });
            }
        }
        return next.handle(req);
    }
}

export const AuthTokenProvider = {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthTokenInterceptor,
    multi: true
};
